/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconRifle: {
  name: 'rifle';
  data: string;
} = {
  name: 'rifle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M551.917 436.856s-22.711 11.355-22.711 39.744v22.711c0 5.678 0 5.678 5.678 5.678h34.066c5.678 0 5.678 0 5.678-5.678V476.6c0-28.389-22.711-39.744-22.711-39.744zm0 14.194s11.355 5.678 11.355 25.55v11.355h-22.711V476.6c0-19.872 11.356-25.55 11.356-25.55zM531.596 513.505h40.641c1.32 0 2.391 1.07 2.391 2.391v9.413c0 1.32-1.07 2.391-2.391 2.391h-40.641a2.391 2.391 0 0 1-2.391-2.391v-9.413a2.392 2.392 0 0 1 2.391-2.391" transform="translate(-3179.79 -2739.972) scale(6.31579)"/></svg>`,
};
